export const CSRF_HEADER = "x-csrf-token";
export const AUTH_HEADER = "Authorization";
